import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from '@mui/material';

const services = [
  {
    id: 1,
    name: 'Restaurações',
    description: 'Recuperação de dentes danificados com materiais estéticos e duradouros.',
    image: '/restauracao.png',
  },
  {
    id: 2,
    name: 'Limpeza e Profilaxia',
    description: 'Remoção de tártaro e placa bacteriana para manter sua saúde bucal.',
    image: '/limpeza.png',
  },
  {
    id: 3,
    name: 'Exodontias',
    description: 'Extração de dentes com segurança e conforto.',
    image: '/exodontia.png',
  },
  {
    id: 4,
    name: 'Clareamento',
    description: 'Deixe seu sorriso mais branco e radiante.',
    image: '/clareamento.png',
  },
  {
    id: 5,
    name: 'Endodontia',
    description: 'Tratamento de canal com técnicas modernas e indolores.',
    image: '/endodontia.png',
  },
  {
    id: 6,
    name: 'Ortodontia',
    description: 'Correção de posicionamento dentário com aparelhos modernos.',
    image: '/ortodontia.png',
  },
  {
    id: 7,
    name: 'Atendimento Infantil',
    description: 'Cuidado especial e carinhoso para os pequenos.',
    image: '/infantil.png',
  },
  {
    id: 8,
    name: 'Toxina Botulínica',
    description:
      'Avaliação e indicação individual, conforme habilitação profissional e legislação vigente.',
    image: '/botox.png',
  },
];

const Services: React.FC = () => {
  return (
    <Box id="services" sx={{ py: 10, bgcolor: '#f9f9f9' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ fontWeight: 700, color: '#9c4f96', mb: 6 }}
        >
          Nossos Serviços
        </Typography>
        <Grid container spacing={4}>
          {services. map((service) => (
            <Grid item xs={12} sm={6} md={3} key={service.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 12px 24px rgba(156, 79, 150, 0.2)',
                  },
                }}
              >
                <CardContent sx={{ textAlign: 'center', flexGrow: 1 }}>
                  <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', height: 120 }}>
                    <img 
                      src={service.image} 
                      alt={service.name}
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    {service.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;